export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9272.2176ea45.jpg";